import type { ModuleConfig } from "@kubdee/shared";
import type { NavGroup } from "@kubdee/ui/shell/app-sidebar";
import { getNavIcon } from "@kubdee/ui/lib/icon-registry";

/**
 * Transform a module's `defineModule()` navigation into the sidebar's
 * `NavGroup[]` shape, resolving icon name strings to Lucide components.
 *
 * This makes `defineModule()` the single source of truth for sidebar
 * navigation, eliminating duplicated `NavGroup[]` definitions in each
 * module's `layout.tsx`.
 *
 * Paths may contain query strings (e.g. `/accounting/invoices?type=sales`);
 * they are passed through unchanged so Next.js `<Link>` handles them.
 */
export function resolveModuleNavigation(moduleConfig: ModuleConfig): NavGroup[] {
  return moduleConfig.navigation.groups.map((group) => ({
    label: group.label,
    items: group.items.map((item) => ({
      title: item.label,
      href: item.path,
      icon: getNavIcon(item.icon),
      ...(item.exact ? { exact: true } : {}),
    })),
  }));
}
